import "./Login.css"; // reuse the same CSS styling
import ResetPasswordForm from "../components/forms/ResetPasswordForm";

function ResetPasswordPage() {
  return (
    <div className="auth-page reset-page">
      <div className="reset-container">
        <ResetPasswordForm />
      </div>
    </div>
  );
}

export default ResetPasswordPage;